import * as React from 'react';



export default class Reset extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="icons/refresh/white" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Page-1" stroke="#FFFFFF">
                <g transform="translate(1.000000, 1.000000)">
                    <path d="M14.1336316,7.10526316 C14.1336316,10.8110526 11.1288947,13.8157895 7.42310526,13.8157895 C4.65442105,13.8157895 2.27731579,12.1389474 1.25178947,9.74526316" id="Stroke-1"></path>
                    <path d="M0.712578947,7.10526316 C0.712578947,3.39947368 3.71731579,0.394736842 7.42310526,0.394736842 C10.2833684,0.394736842 12.7267895,2.18447368 13.6915263,4.70526316" id="Stroke-3"></path>
                    <polyline id="Stroke-5" points="11.6665263 4.41615789 13.8131053 4.93405263 14.5038947 3.183"></polyline>
                    <polyline id="Stroke-7" points="0.367184211 11.25 1.10692105 9.375 3.15481579 10.0413158"></polyline>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
